import { container, TYPES } from '@/core/container'
import { IDriverRepository } from '@/core/domain/repositories/IDriverRepository'
import { IRideRepository } from '@/core/domain/repositories/IRideRepository'
import { ISolicitationRepository } from '@/core/domain/repositories/ISolicitationRepository'
import { IAuthRepository } from '@/core/domain/repositories/IAuthRepository'
import { GraphQLDriverRepository } from '@/infrastructure/repositories/GraphQLDriverRepository'
import { GraphQLRideRepository } from '@/infrastructure/repositories/GraphQLRideRepository'
import { GraphQLSolicitationRepository } from '@/infrastructure/repositories/GraphQLSolicitationRepository'
import { AxiosAuthRepository } from '@/infrastructure/repositories/AxiosAuthRepository'
import { GraphQLClientInterface } from '@/infrastructure/graphql/apolloClient'
import { HttpClient } from '@/infrastructure/http/axiosClient'

export const setupRepositoryBindings = () => {
  // Driver Repository
  container.registerFactory<IDriverRepository>(TYPES.DriverRepository, () => {
    const graphqlClient = container.resolve<GraphQLClientInterface>(
      TYPES.GraphQLClient
    )
    return new GraphQLDriverRepository(graphqlClient)
  })

  // Ride Repository
  container.registerFactory<IRideRepository>(TYPES.RideRepository, () => {
    const graphqlClient = container.resolve<GraphQLClientInterface>(
      TYPES.GraphQLClient
    )
    return new GraphQLRideRepository(graphqlClient)
  })

  container.registerFactory<ISolicitationRepository>(
    TYPES.SolicitationRepository,
    () => {
      const graphqlClient = container.resolve<GraphQLClientInterface>(
        TYPES.GraphQLClient
      )
      return new GraphQLSolicitationRepository(graphqlClient)
    }
  )

  // Auth Repository
  container.registerFactory<IAuthRepository>(TYPES.AuthRepository, () => {
    const httpClient = container.resolve<HttpClient>(TYPES.AxiosClient)
    return new AxiosAuthRepository(httpClient)
  })
}
